import { useEffect, useMemo } from 'react';

// DEPENDENCIES
import camelCase from 'lodash/camelCase';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

// GLOBAL VARIABLES
import { VIEW_STATUSES } from 'globals.js';

// FUNCTIONS
import { getPathByStatus } from 'functions.js';

// HELPERS
import useRecordView from 'helpers/getRecordView';

// MAIN COMPONENT
export const viewRedirect = Component => {
  return ({ status, ...props }) => {
    // ROUTER
    const navigate = useNavigate();
    const { pathname, state } = useLocation();
    const { recordID } = useParams();

    const { view } = useRecordView();

    const to = useMemo(() => getPathByStatus(status, recordID), [recordID, status]);

    const viewStatuses = VIEW_STATUSES[camelCase(view)]?.statuses;

    // EFFECTS
    useEffect(() => {
      if (!to.includes(pathname) && status && !viewStatuses?.includes(status)) {
        navigate(to, { state });
      }
    }, [navigate, viewStatuses, pathname, state, status, to, view]);

    // RENDER
    return <Component {...props} status={status} />;
  };
};
